import * as React from 'react';
import { SvgSpacesMastheadTable } from '../../../gen-src/icons/SpacesMastheadTable';
import { SvgSpacesMediumTable } from '../../../gen-src/icons/SpacesMediumTable';
import { SvgSpacesMediumTableCertified } from '../../../gen-src/icons/SpacesMediumTableCertified';
import { placePageIconClass } from '../style/PlaceStyles';

export interface TableIconProps {
  readonly isCertified: boolean | null;
}

export function TableMastheadIcon(): JSX.Element {
  return <SvgSpacesMastheadTable className={placePageIconClass} />;
}

export function TableMediumIcon(props: TableIconProps): JSX.Element {
  return props.isCertified ? <SvgSpacesMediumTableCertified /> : <SvgSpacesMediumTable />;
}
